import * as cookie from 'react-cookies';

import { AiContentDownloadEvent } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentDownloadEvent';
import { AiContentFeedbackEvent } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentFeedbackEvent';
import { AiContentFeedbackScore } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentFeedbackScoreEnum';
import { AiContentType } from '@videoblocks/events-ts/lib/storyblocks/content/ai/AiContentTypeEnum';
import { AiContentIdentifiers } from '@videoblocks/events-ts/lib/storyblocks/content/ai/records/AiContentIdentifiers';

import events from './Events';

export enum AiContentEventCookies {
  VIDEO_EDIT_ID = 'video_edit_id',
  LAST_VIDEO_EDIT_ID = 'last_video_edit_id',
}

type AiContentEvent = AiContentDownloadEvent | AiContentFeedbackEvent;

export default class AiContentEventFactory {
  static buildAiContentIdentifiers(
    contentId: number | null = null
  ): AiContentIdentifiers {
    const aiContentIdentifiers = new AiContentIdentifiers();
    aiContentIdentifiers.aiContentId = cookie.load(
      AiContentEventCookies.VIDEO_EDIT_ID
    );
    aiContentIdentifiers.lastAiContentId = cookie.load(
      AiContentEventCookies.LAST_VIDEO_EDIT_ID
    );
    aiContentIdentifiers.aiContentType = AiContentType.AI_VIDEO_EDIT;
    aiContentIdentifiers.contentId = contentId?.toString() ?? null;
    return aiContentIdentifiers;
  }

  private static setCommonEventFields<T extends AiContentEvent>(
    event: T,
    contentId: number | null = null
  ): T {
    event.meta = events.meta();
    event.user = events.user();
    event.device = events.device();
    event.urls = events.urls();
    event.geo = events.geo();

    // todo: maybe just remove this from the event?
    event.ipAddress = null;

    event.aiContentIdentifiers = this.buildAiContentIdentifiers(contentId);

    return event;
  }

  static createDownloadEvent(
    contentId: number | null = null
  ): AiContentDownloadEvent {
    return this.setCommonEventFields(new AiContentDownloadEvent(), contentId);
  }

  static createFeedbackEvent(
    aiContentFeedbackMessage: null | string = null,
    aiContentFeedbackScore: null | AiContentFeedbackScore = null,
    contentId: number | null = null
  ): AiContentFeedbackEvent {
    const event: AiContentFeedbackEvent = this.setCommonEventFields(
      new AiContentFeedbackEvent(),
      contentId
    );
    event.aiContentFeedbackMessage = aiContentFeedbackMessage;
    event.aiContentFeedbackScore = aiContentFeedbackScore;
    return event;
  }
}
